import { useParams } from 'react-router-dom';
import { useClientQuery } from '../../queries/use-client.js';
import { ClientNavigation } from './ClientNavigation.js';

/**
 * Header rendered above every `/clients/:id/*` sub-tab page.
 *
 * Layout: optional small client logo on the left, the tenant name in
 * bold, then the {@link ClientNavigation} sub-tabs spanning the right
 * side. While the client query is loading we show a spinner so the
 * sub-tabs don't pop in mid-render.
 */
export function ClientHeader(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const { data } = useClientQuery(id);

  return (
    <div className="flex flex-row items-center space-x-3 border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      {data?.smallLogoUrl ? (
        <img
          src={data.smallLogoUrl}
          alt=""
          height={32}
          width={32}
          className="mr-2 min-w-[32px] rounded-lg"
        />
      ) : null}
      <span className="line-clamp-2 grow whitespace-nowrap text-lg font-bold text-gray-800 dark:text-gray-200">
        {/* While loading, render an empty space so the navbar doesn't shift —
            the sub-tab pills are the more important affordance and can show
            without the name. */}
        {data?.name ?? ' '}
      </span>
      <ClientNavigation />
    </div>
  );
}
